import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const floatingActionMenuDefaultVariants = {}
const floatingActionMenuCompoundVariants = []

const floatingActionMenuSlotNames = [
  [
    "root",
    "FloatingActionMenu__root"
  ],
  [
    "title",
    "FloatingActionMenu__title"
  ]
]
const floatingActionMenuSlotFns = /* @__PURE__ */ floatingActionMenuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, floatingActionMenuDefaultVariants, getSlotCompoundVariant(floatingActionMenuCompoundVariants, slotName))])

const floatingActionMenuFn = memo((props = {}) => {
  return Object.fromEntries(floatingActionMenuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const floatingActionMenuVariantKeys = []
const getVariantProps = (variants) => ({ ...floatingActionMenuDefaultVariants, ...compact(variants) })

export const floatingActionMenu = /* @__PURE__ */ Object.assign(floatingActionMenuFn, {
  __recipe__: false,
  __name__: 'floatingActionMenu',
  raw: (props) => props,
  variantKeys: floatingActionMenuVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, floatingActionMenuVariantKeys)
  },
  getVariantProps
})